export const datePickerLocale = {
    format: 'MM/dd/yyyy',
    pattern: '[0-9]{1,2}/[0-9]{1,2}/[0-9]{1,4}',
    dateLocale: 'en-US',
    weekStartsOn: 0,
    previousMonthLabel: 'Previous month',
    nextMonthLabel: 'Next month',
    openCalendarLabel: 'Open calendar view',
    calendarOverlayLabel: 'Select a date',
    cancelLabel: 'Cancel',
    changeLabel: 'Change',
    confirmLabel: 'Confirm',
    monthSelectorLabel: 'Month',
    yearSelectorLabel: 'Year',
};
//# sourceMappingURL=DatePicker.locale.js.map